module.exports = __webpack_public_path__ + "img/image-bpg.48beab7a.png";